import React from 'react';
import { TableContainer, Table, TableHead, TableCell, TableRow, Typography } from '@common-ui/ui';
import workItemEnum from '../../enums/workItemEnum';

export default function ImageInfo({ image }) {
  const ImageData = () =>
    Object.keys(image).map((key, index) => (
      <TableRow key={index}>
        <TableCell align="left">
          <Typography>{key}</Typography>
        </TableCell>
        <TableCell align="right">
          <Typography>{image[key]}</Typography>
        </TableCell>
      </TableRow>
    ));

  return (
    <div>
      <Typography variant="h5" className="workItem__header">
        {workItemEnum.IMAGE_INFO}
      </Typography>
      <TableContainer>
        <Table>
          <TableHead>
            <ImageData />
          </TableHead>
        </Table>
      </TableContainer>
    </div>
  );
}
